<template>
    <div class="col-one-layout">
    <!--      <div class="map-component" >
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2433.85426019236!2d16.890545712540284!3d52.40931751007977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470444c5dbba077f%3A0x225127eba3866a59!2sUniwersyteckie+Centrum+Stomatologii+i+Medycyny+Specjalistycznej+Sp%C3%B3%C5%82ka+z.+o.o.!5e0!3m2!1spl!2spl!4v1537279742301" 
                    width="1000" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
    
        </div>-->

    <div class="map-component" >
<!--        <iframe src="https://goo.gl/maps/vcXq9uzUafN2" 
                width="1000" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>-->
        <iframe src="https://www.google.com/maps/d/embed?mid=128wvDlBMxlQRUluibyDX33f34c8jdGYj&hl=pl"   
                width="1000" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>
    </div>
</template>

<script>
    export default {
        name: 'Map'
    }
</script>





// WEBPACK FOOTER //
// src/components/Map.vue